export default __webpack_public_path__ + "43422c2b6989b954090d5571319e5273.svg";